import { useIntl } from 'react-intl';

import { LinkReason } from 'services/user';

import { Tooltip } from 'components';

import { LinkSourceTooltipProps } from './types';

import * as S from './styles';

const LinkSourceTooltip: React.FC<LinkSourceTooltipProps> = ({
  linkReason,
  translatedReason,
}) => {
  const intl = useIntl();

  const linkReasonTooltipMap: Partial<Record<LinkReason, string>> = {
    user_not_satisfied_with_cp_suggestions: 'CHOICE',
    user_potentially_critical_not_satisfied_with_cp_suggestions:
      'CRITICALPOTENTIAL',
    user_with_accesssibility_needs: 'ACCESSIBILITY',
  };

  const linkReasonKey =
    linkReason && linkReasonTooltipMap[linkReason]
      ? `DASHBOARD.TC.TOOLTIP.${linkReasonTooltipMap[linkReason]}`
      : '';

  const tooltipDescription = linkReasonKey
    ? intl.formatMessage({ id: linkReasonKey })
    : '';

  return (
    <S.TooltipContainer data-testid="link_source_tooltip">
      <Tooltip
        width={200}
        height={200}
        position="top-center"
        available={!!tooltipDescription}
        description={tooltipDescription}
      >
        {translatedReason}
      </Tooltip>
    </S.TooltipContainer>
  );
};

export default LinkSourceTooltip;
